window.help = () => {
    return {
        setHeight() {
            let items = document.querySelectorAll('.item-content');

            const myObserver = new ResizeObserver(entries => {
                let help = document.querySelector('.help-bg-large');
                let subCat = document.querySelector('#sub-categories-large');
                
                entries.forEach(entry => {
                    
                    let h = entry.contentRect.height;

                    if (h > 0) {
                        help.style.height = `${h}px`;
                        subCat.style.height = `${h}px`;
                    }
                });
              });

              items.forEach(item => {
                  myObserver.observe(item)
              });
        }
    }
}